import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { dietQualityColors } from '../../lib/themes/generalTheme';

/**
 * @description DietQualityBar component
 *
 * @param {number} currentScore
 * @param {number} goalScore
 * @returns
 */
const DietQualityBar = ({ currentScore, goalScore, size = 'large' }) => {
  // The parent component should set this?
  // const isMobileView = useMediaQuery('(max-width: 600px)');
  const theme = useTheme();

  // Changing 0 to null to show a lighter colored bar

  // if currentScore is 0 set to null
  if (currentScore === 0) {
    currentScore = null;
  }

  // if goalScore is 0 set to null
  if (goalScore === 0) {
    goalScore = null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        height: '51px',
        alignItems: 'flex-start',
        gap: '2px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        opacity: goalScore === null && currentScore === null ? 0.5 : 1,
        width: '100%',
        resize: 'none',
        maxWidth: size === 'large' ? '100%' : '100%',
        minWidth: size === 'large' ? '325px' : '80%',
        cursor: 'default',
        userSelect: 'none',
        '& > div': {
          resize: 'none',
        },
      }}
    >
      {dietQualityColors.map((color, index) => {
        const isCurrent = index === currentScore - 1;
        const isGoal = index === goalScore - 1;
        const isHighlighted = isCurrent || isGoal;
        return (
          <Box
            key={index}
            sx={{
              height: isHighlighted ? '48px' : '24px',
              flex: '1 1 0',
              minWidth: 0,
              backgroundColor: color,
              borderRadius: isHighlighted
                ? '4px'
                : index === 0
                ? '4px 0px 0px 4px'
                : index === dietQualityColors.length - 1
                ? '0px 4px 4px 0px'
                : '0px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              padding: isHighlighted ? '8px' : '0px',
            }}
          >
            {isHighlighted && (
              <>
                <Typography
                  variant="sm"
                  sx={{
                    color: theme.palette.text.primary,
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '14px',
                  }}
                >
                  {isCurrent ? 'Now' : 'Goal'}
                </Typography>
                <Typography
                  sx={{
                    color: theme.palette.text.primary,
                    leadingTrim: 'both',
                    textEdge: 'cap',
                    fontSize: '16px',
                    fontWeight: 700,
                    lineHeight: 'normal',
                  }}
                >
                  {index + 1}
                </Typography>
              </>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default DietQualityBar;
